// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"ae86a64f","344":"df59b032","403":"3e75edba","644":"b6426ba0","748":"fa16a074","944":"936341d0"}[chunkId] + ".chunk.js";
};